<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { Amount, required } from '../../../../utils/validation'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import DateInput from '../../../../components/ui/form/DateInput.vue'
import AmountInput from '../../../../components/ui/form/AmountInput.vue'
import { isEmpty } from '../../../../utils/CommonFunctions'

const props = defineProps<{
  data?: any | null
  currency?: any| null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  currencys_id: props.data?.currencys_id || props.currency?.id || '',
  from_date: props.data?.from_date ? new Date(props.data?.from_date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
  to_date: props.data?.from_date ? new Date(props.data?.to_date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
  rate: props.data?.rate || 0,
  active: props.data?.active || true,
  uid: props.data?.uid || '',
})

setFieldRules('currencys_id', [required('Currency is required')])
setFieldRules('from_date', [required('From Date is required')])
setFieldRules('rate', [required('Rate is required'), Amount('Rate cannot be 0')])


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update-exchange-rate' : 'create-exchange-rate'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
      if (props.data.from_date)
        fields.value.from_date.value = new Date(props.data?.from_date).toISOString().slice(0, 10)
      if (props.data.to_date)
        fields.value.to_date.value = new Date(props.data?.to_date).toISOString().slice(0, 10)
    }
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        <div>
          <SearchSelect 
          v-model="fields.currencys_id.value" endPoint="finance/master-data/currency" label="Currency" 
          :readonly="isReadOnly || !isEmpty(props.currency)" :allow-new-record="true" 
          :error="fields.currencys_id.touched ? fields.currencys_id.error : null"
          @blur="fields.currencys_id.touched = true"
          />
        </div>
        <div></div>

        <!-- From Date -->
         <DateInput
            v-model="fields.from_date.value" 
            label="From Date"
            placeholder="Select From Date"
            :readonly="isReadOnly"
            :error="fields.from_date.touched ? fields.from_date.error : null"
            @blur="fields.from_date.touched = true"
         />

        <!-- To Date (Optional) -->
        <DateInput 
            v-model="fields.to_date.value" 
            label="To Date"
            placeholder="Select To Date"
            :readonly="isReadOnly"
            :error="fields.to_date.touched ? fields.to_date.error : null"
            @blur="fields.to_date.touched = true"
         />

        <!-- Exchange Rate -->
        <AmountInput
          v-model="fields.rate.value"
          type="number"
          label="EXchange Rate"
          :readonly="isReadOnly"
          :min="1"
          :error="fields.rate.touched ? fields.rate.error : null"
          @blur="fields.rate.touched = true"
        />
</div>
    </template>
  </ModalFormTemplate>
</template>